import React, { useEffect, useRef } from "react";
import create from "zustand";

const store = (set, get) => ({
  hotspotRefs: {},
  addHotspotRef: (data) => {
    console.log("zustand hotspot ref", data);
    const { hotspotRefs } = get();
    hotspotRefs[data.hotspotId] = data.hotspotRef;
    set({ hotspotRefs });
  },
  hotspots: {},
  addHotspot: (hotspotId) => {
    const { hotspots } = get();
    const newHotspot = { [hotspotId]: true };
    set({ hotspots: { ...hotspots, ...newHotspot } });
  },
});

const useHotspotStore = create(store);
export const HotspotControllerState = useHotspotStore.getState;

// eslint-disable-next-line no-unused-vars
const HotspotUI = ({ hotspotId }) => {
  console.log("rendering individual hotspot", hotspotId);
  const addHotspotRef = useHotspotStore((state) => state.addHotspotRef);
  const hotspotRef = useRef(null);

  useEffect(() => {
    if (hotspotRef)
      addHotspotRef({ hotspotId, hotspotRef: hotspotRef.current });
  }, [addHotspotRef, hotspotId, hotspotRef]);

  return (
    <div ref={hotspotRef} style={{ position: "absolute" }}>
      <button
        type="button"
        onClick={() => {
          console.log("hotspot clicked");
        }}
      >
        {hotspotId}
      </button>
    </div>
  );
};

export const HotspotController = () => {
  const hotspots = useHotspotStore((state) => state.hotspots);
  console.log(
    "rendering hotspots",
    JSON.stringify(hotspots),
    Object.keys(hotspots)
  );
  return (
    <div>
      {Object.keys(hotspots).map((hotspotId) => (
        <HotspotUI key={hotspotId} hotspotId={hotspotId} />
      ))}
    </div>
  );
};
